import React, { FC } from 'react'

import { Field } from 'redux-form'

import { Box } from '@material-ui/core'

import Paths from '~/utils/paths'

import { acceptedText, newsText } from '~/data/mocks/listingInfo'

import CheckboxField from '../fields/CheckboxField/CheckboxField'

import Link from './Link'
import Text from './Text'

const CheckboxSection: FC = () => {
  return (
    <>
      <Box mt={2} mb={1.5}>
        <Field
          id="privacy"
          name="privacy"
          label={
            <>
              <Text component="span">{acceptedText}</Text>{' '}
              <Link href={Paths.privacy.index}> here.</Link>
            </>
          }
          component={CheckboxField}
        />
      </Box>

      <Field
        id="update_me_with_latest_news"
        name="update_me_with_latest_news"
        label={newsText}
        component={CheckboxField}
      />
    </>
  )
}

export default CheckboxSection
